console.info("VMS Form v1.4");
if (typeof app === "undefined") {
  var app = {
    config: {
      projectName: null,
    },
    private: {
      hasSecondWheelchair: {
        do_yes: function () {
          TDForm.helper.showSection("second-wheelchair-info");
        },
        do_no: function () {
          TDForm.helper.hideSection("second-wheelchair-info");
        },
      },
      getOpportunityName: function () {
        let name = document.getElementById("username").value;
        return name;
      },
      getVMSDescription: function () {
        let newLine = "\r\n";
        let vmsDescription = "";

        if (document.getElementById("condition-characteristics").value) {
          vmsDescription += "Condition Characteristics: ";
          vmsDescription += newLine;
          vmsDescription += document.getElementById(
            "condition-characteristics",
          ).value;
          vmsDescription += newLine + newLine;
        }

        for (let i = 1; i < 4; i++) {
          if (document.getElementById("stand-description" + i)) {
            vmsDescription += "Stand Description " + i + ": ";
            vmsDescription += newLine;
            vmsDescription += document.getElementById(
              "stand-description" + i,
            ).value;
            vmsDescription += newLine + newLine;
          }
        }

        if (document.getElementById("switch-additional-information").value) {
          vmsDescription += "Switch/joystick additional information: ";
          vmsDescription += newLine;
          vmsDescription += document.getElementById(
            "switch-additional-information",
          ).value;
        }
        return vmsDescription;
      },
      getOpportunityValues: function () {
        let op = {
          Name: app.private.getOpportunityName(),
          Stage: "Qualification",
          RecordTypeId: "012QD000002dmwT",
          CloseDateDuration: 30,
          Devices: document.getElementById("device-manufacturer-and-model")
            .selectedOptions[0].value,
          CurrencyIsoCode: "EUR",
          OpType: document.getElementById("oppType").value,
          VMSDescription: app.private.getVMSDescription(),
          Country: document.getElementById("country").value,
        };

        return JSON.stringify(op);
      },
      device:{
        undo: function(){
          TDForm.helper.hideField("other-devices");
          TDForm.helper.hideField("additional-phone-holder");
        },
        do_show_other:function(){
          app.private.device.undo();
          TDForm.helper.showField("other-devices", true);
        },
        do_show_phone_holder: function(){
          app.private.device.undo();
          TDForm.helper.showField("additional-phone-holder", true);
        }
      }
    },
    helper: {},
    changeHandler: {
      secondWheelchair: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "Yes":
            app.private.hasSecondWheelchair.do_yes();
            break;
          case "No":
            app.private.hasSecondWheelchair.do_no();
            break;
          default:
            app.private.hasSecondWheelchair.do_no();
            break;
        }
      },
      devices: function (select) {
        let selectedOption = select.value;
        switch (selectedOption) {
          case "Other":
            app.private.device.do_show_other();
            break;
          case "I-110":
          case "I-16":
          case "I-13":
          case "TD Pilot":
          case "TD PC Eye":
            app.private.device.do_show_phone_holder();
            break;
          default:
            app.private.device.undo();
            break;
        }   
      }
    },
    doSubmit: function () {
      document.getElementById("op_values").value =
        app.private.getOpportunityValues();
      document.getElementById("op_description").value =
        TDForm.helper.getDescriptionFromIds();
    },
    uploadSymbol: function (e) {
      const hostURL =
        "https://files.tbdvoxmarketing.com/FileReceiver?code=yChKWANZqrnJ2UB8nF10GskjdGUQjoYvRryMIyoje66HAzFuli6orA==";
      if (app.config.projectName === null) {
        app.config.projectName = "vms";
      }
      TDForm.attachment.uploadFile(e, hostURL, app.config.projectName);
    },
  };
}
